import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import { EstadoPreventaEnum, ModulosEnumChoice, ROUTER_PATHS, TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { GeneralTable, useModalMotivoRechazo } from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTableColumnsPreventaPymes } from "@/erp/venta_pymes/preventa/shared/hook/useTableColumnsPreventaPymes";
import { useGetPreventasPymes } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import { IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";

export default function TableClientesPymes() {

  ///* Hook
  const { columnsPreventa } = useTableColumnsPreventaPymes(EstadoPreventaEnum.PENDIENTE_DOCUMENTOS);


  const navigate = useNavigate();

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventasPymes(
      {
        estado_preventa: EstadoPreventaEnum.PENDIENTE_DOCUMENTOS,
        //pre_requiere_contrato_fisico: true,
        requiere_contrato_fisico: true,
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_preventa_before: dateBefore,
        fecha_preventa_after: dateAfter,
        user_create: vendedor,
        ...filterObject,
        filterByState: false
      }
    );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}

            setVendedor={setVendedor}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaPymes>
            columns={columnsPreventa}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={true}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Tooltip placement='top' title='Ver Contrato'>
                    <IconButton
                      onClick={() => {
                        //setOpenModal(true)
                        //if (!value.contrato_data) return;
                        //descargarPdfDesdeurl(value.contrato_data?.url_contrato, `${value.numero_referencia}.pdf`);
                        navigate(`${ROUTER_PATHS.clientes.solicitudContratoPymesNav}/${value.id_preventa_pymes}`)
                      }}
                    >
                      <VisibilityIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />


    </>
  )

}